import App from './components/App.vue'
import { store, dataStore } from './stores'
import { vueRouter } from './router'
import i18n from './i18n'
import Vuetify from 'vuetify'
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'

export default {
  elementId: 'client_site',
  rootComponent: App,
  vueRouter,
  stores: [
    {
      key: ['ClientSite'],
      module: store
    }
  ],
  i18n,
  vuetify: new Vuetify({
    icons: {
      iconfont: 'mdi'
    }
  }),
  data: {
    dataStore: dataStore
  }
}
